import type { Widget } from '@/types/pagebuilder'

export type ExtraSectionPosition =
  | 'before_gallery'
  | 'after_gallery'
  | 'before_store'
  | 'after_store'
  | 'before_products'
  | 'after_products'
  | 'footer'

export type ExtraSectionBackgroundType = 'color' | 'gradient' | 'pattern'

export type ExtraSectionPatternType =
  | 'animated-balls'
  | 'rain-lines'
  | 'gradient-waves'
  | 'floating-circles'

export interface ExtraSection {
  id: number
  title: string
  content?: string
  widgets?: Widget[]
  position: ExtraSectionPosition | string
  is_active: boolean
  gallery?: string[]
  image?: string
  layout?: string
  background_color?: string
  transparent_background?: boolean
  background_type?: ExtraSectionBackgroundType
  gradient_type?: 'linear' | 'radial'
  gradient_angle?: number
  gradient_color1?: string
  gradient_color2?: string
  gradient_color1_location?: number
  gradient_color2_location?: number
  pattern_type?: ExtraSectionPatternType
  pattern_color?: string
  pattern_color2?: string
  border_radius?: number | string
  section_margin?: string
  section_padding?: number | string
  box_shadow?: boolean
  backdrop_blur?: boolean
  title_color?: string
  title_size?: string
  section_size?: string
  collapsed?: boolean
  hidden_on_mobile?: boolean
  category_ids?: number[]
  product_limit?: number
  excursion_limit?: number
}

export const EXTRA_SECTION_POSITIONS: {
  value: ExtraSectionPosition
  label: string
  icon: string
}[] = [
  { value: 'before_gallery', label: 'Πριν το Gallery', icon: '🖼️' },
  { value: 'after_gallery', label: 'Μετά το Gallery', icon: '🖼️' },
  { value: 'before_store', label: 'Πριν το Κατάστημα', icon: '🏪' },
  { value: 'after_store', label: 'Μετά το Κατάστημα', icon: '🏪' },
  { value: 'before_products', label: 'Πριν τα Προϊόντα', icon: '📦' },
  { value: 'after_products', label: 'Μετά τα Προϊόντα', icon: '📦' },
  { value: 'footer', label: 'Στο Footer', icon: '📄' },
]

export const DEFAULT_EXTRA_SECTION: Omit<ExtraSection, 'id'> = {
  title: '',
  content: '',
  widgets: [],
  position: 'after_store',
  is_active: true,
  gallery: [],
  layout: 'page_builder',
  background_color: '#ffffff',
  transparent_background: false,
  background_type: 'color',
  gradient_type: 'linear',
  gradient_angle: 135,
  gradient_color1: '#3b82f6',
  gradient_color2: '#2563eb',
  gradient_color1_location: 0,
  gradient_color2_location: 100,
  pattern_type: 'animated-balls',
  pattern_color: '#006D5B',
  pattern_color2: '#FF6F61',
  title_color: '#212529',
  title_size: 'h2',
  section_size: 'medium',
  box_shadow: true,
  backdrop_blur: true,
  hidden_on_mobile: false,
}
